import { useConfirm } from 'primevue/useconfirm';
import { useToast } from 'primevue/usetoast';

export function useConfirmRemove() {
    const confirm = useConfirm();
    const toast = useToast();

    const confirmRequest = (entity, callback, operation = null) => {
        // const entityName = entity?.name ?? entity?.code ?? 'item';
        const message = operation === 'default' ? 'set it as default' : operation === 'remove' ? 'remove it' : 'delete it';
        confirm.require({
            header: 'Confirmation',
            message: 'Are you sure you want to ' + message + '?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                callback(parseInt(entity?.id));
            },
            reject: () => {
                toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
            },
        });
    };

    const confirmTransfer = (entities, exportflag, callback) => {
        confirm.require({
            header: 'Confirmation',
            message: 'Are you sure you want to  transfer these items?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                callback(entities, exportflag);
            },
            reject: () => {
                toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
            },
        });
    };

    const confirmChange = (entities, callback) => {
        confirm.require({
            header: 'Confirmation',
            message: 'Are you sure you want to proceed?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                callback(entities);
            },
            reject: () => {
                toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
            },
        });
    };

    const confirmContinue = (message, positiveFlag = false) => {
        return new Promise((resolve) => {
            const displayMessage = `${message} Are you sure you want to continue?`;
            return confirm.require({
                header: 'Confirmation',
                group: 'continue-confirmation',
                message: displayMessage,
                icon: positiveFlag ? 'pi pi-check-circle' : 'pi pi-exclamation-circle',
                accept: () => {
                    resolve(true);
                },
                reject: () => {
                    resolve(false);
                },
            });
        });
    };

    return {
        confirmRequest,
        confirmTransfer,
        confirmChange,
        confirmContinue,
    };
}
